import styled from 'styled-components';

export const SectionContainer = styled.div`
	margin-bottom: 1.5rem;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const SectionTitle = styled.p`
	color: ${({ theme }) => theme.text};
	font-size: 1rem;
	font-weight: bold;
	margin: 0 0 0.5rem;
`;

export const HelperTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	border: 1px solid ${({ theme }) => theme.border};
	border-radius: 8px;
	overflow: hidden;
`;

export const HelperThead = styled.thead`
	background-color: ${({ theme }) => theme.primaryOpacity};
`;

export const HelperTh = styled.th`
	padding: 0.5rem 0.75rem;
	text-align: left;
	border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const HelperTd = styled.td`
	padding: 0.5rem 0.75rem;
	border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const HelperTr = styled.tr`
	&:last-child td {
		border-bottom: none;
	}

	&:nth-child(even) {
		background-color: ${({ theme }) => theme.backgroundGray};
	}
`;
